exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3W-zkl4-bnVKzJ{background:#eb5a46!important}._3W-zkl4-bnVKzJ:hover{background:#cf513d!important}._1uYU0QYZXZMi9f,._1uYU0QYZXZMi9f:focus{background-color:#00c2e0}._1uYU0QYZXZMi9f:active,._1uYU0QYZXZMi9f:hover{background-color:#00aecc}", ""]);

// exports
exports.locals = {
	"newNotifications": "_3W-zkl4-bnVKzJ",
	"hasOtherNotifications": "_1uYU0QYZXZMi9f"
};